import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";

export const WEBHOOK_DELIVERY_QUERY_KEY = "useWebhookDeliveryQuery";

const PENDING_POLL_INTERVAL_MS = 5000;

/** One delivery with its request body and every attempt. */
export const useWebhookDeliveryQuery = (
  endpointId: string,
  deliveryId: string | null
) => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: [
      WEBHOOK_DELIVERY_QUERY_KEY,
      apiClient.slug,
      endpointId,
      deliveryId
    ],
    queryFn: async () => {
      if (!deliveryId) return null;
      return apiClient.orgOrOfficeSettings.getWebhookEndpointDelivery(
        endpointId,
        deliveryId
      );
    },
    enabled: !!apiClient.slug && !!endpointId && !!deliveryId,
    // A delivery keeps changing after it was last viewed (retries run in the
    // background), so never trust the cache when it's opened again.
    staleTime: 0,
    refetchInterval: (q) =>
      q.state.data?.status === "pending" ? PENDING_POLL_INTERVAL_MS : false
  });
};
